module.exports = __webpack_public_path__ + "static/media/explosion.aaa711f2.gif";